import React, {Component} from "react";
import {APIClient} from "../utils/APIClient";
import {ModalBody, ModalFooter} from "reactstrap";

export class EditElementModalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getSubmitUrl() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    getDataToSubmit(event) {
        throw new Error('This method must be overridden in the concrete component.');
    }

    renderSaveButton() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: true});
        const submit_url = this.getSubmitUrl();

        const dataToSubmit = this.getDataToSubmit(event)

        new APIClient(submit_url).call('PUT', dataToSubmit).then((response) => {
            this.setState({saving: false});
            if (response.status === 'ERROR') {
                alert(response['error_message']);
            } else if (response.status === 'OK') {
                this.props.onModified(response.data);
            }
        })
    }

    renderFormFields() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    {this.renderFormFields()}
                </ModalBody>
                <ModalFooter>
                    {this.renderSaveButton()}
                </ModalFooter>
            </form>
        )
    }
}
